<head>
    <style>
        .my-pagination /deep/ .ngx-pagination .current {
            font-family: "Graphik SemiBold";
            font-weight: normal;
            font-style: normal;
            font-display: swap;
            color: #265d6e;
            background: transparent;
        }
    </style>
</head>
<div class="container-fluid">
    <div id="success-alert" class="alert alert-success alert-dismissible fade show" role="alert">
        <strong id="videoTitle"></strong> <span id="message"> </span>
        <button (click)="closeSuccessAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div id="error-alert" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span id="error-message"></span>
        <button (click)="closeErrorAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <nav class="navbar navbar-light sub-nav">
        <a class="navbar-brand" [routerLink]="['/home']">
            <h5 class="Ws-subtitle">{{constants.WINDOW_QUEUE_TXT}}</h5>
        </a>
        <span class="navbar-text justify-content-end">
            <input id="search" class="search" type="text" placeholder="search" (ngModelChange)="Search()"
                [(ngModel)]="videoTitle" (ngModelChange)="Search()">
        </span>
    </nav>
    <div class="row">
        <div class="col-6">
            <img class="video-player" *ngIf="videos?.length === 0 || isLoading" src="{{constants.PLAYER_SKELTON_IMG}}" alt="">
            <div class="processing-player" *ngIf="isVimeoProcessing"><span class="processing-player-txt"><mat-progress-spinner
                        mode="indeterminate" diameter="24" color="white">
                    </mat-progress-spinner>This video is being processed by Vimeo…</span></div>
            <div id="video-player" *ngIf="!isVimeoProcessing && videos?.length > 0"></div>
            <div class="row" id="title-container">
                <div class="col" style="width: 100%;">
                    <img class="video-title " *ngIf="isLoading" src="{{constants.VIDEO_TITLE_SKELTON_IMG}}" alt="">
                    <p id="currentVideoTitle" class="video-title col-8">{{currentVideoTitle}}</p>
                </div>
                <div class="col-3">
                    <button id="edit-details" [disabled]="isProcessing" (click)="onClickEdit($event)"
                        class="edit-details ">{{constants.EDIT_TXT}}</button>
                </div>
            </div>
            <div class="row edit-form-container" id=edit-form>
                <form action="" [formGroup]="titleEdit">
                    <input class="input-title-edit col-3" type="text" placeholder="NickName" formControlName="nickName">
                    <input class="input-title-edit col-4" type="text" placeholder="Location" formControlName="location">
                    <input class="input-title-edit col-4" type="text" placeholder="Country" formControlName="country">
                    <div class="edit-tag-container" formGroupName="tags">
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="animals" formControlName="Animals">
                            <label for="animals">animals</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="rain" formControlName="Rain">
                            <label for="rain">rain</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="snow" formControlName="Snow">
                            <label for="snow">snow</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="city" formControlName="City">
                            <label for="city">city</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="nature" formControlName="Nature">
                            <label for="nature">nature</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="night" formControlName="Night">
                            <label for="night">night</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="day" formControlName="Day">
                            <label for="day">day</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="interior" formControlName="Interior">
                            <label for="interior"> interior</label>
                        </div>
                        <div>
                            <input class="edit-tag" type="checkbox" name="" id="water" formControlName="Water">
                            <label for="water"> Water</label>
                        </div>
                    </div>
                    <button id="cancel" (click)="onClickCancel($event)" class="cancel">{{constants.CANCEL_TXT}}</button>
                    <button [disabled]="isEditProcessing" id="done" (click)="onClickDone($event)" class="done">
                        <span *ngIf="isEditProcessing" class="spinner-border spinner-border-sm name-update-spinner"
                            role="status" aria-hidden="true"></span>{{constants.DONE_TXT}}</button>
                </form>
            </div>
            <div class="tag-container" id="tag-container">
                <div disabled class="checkbox-button" [ngClass]="{'checkbox-button-active': animalsActive}">
                    <input class="tag-checkbox" id="animals" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="animals" id="animals-label" class="label-text">{{constants.ANIMALS_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': rainActive}">
                    <input class="tag-checkbox" id="rain" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="rain" id="rain-label" class="label-text">{{constants.RAIN_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': snowActive}">
                    <input class="tag-checkbox" id="snow" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="snow" id="snow-label" class="label-text">{{constants.SNOW_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': cityActive}">
                    <input class="tag-checkbox" id="city" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="city" id="city-label" class="label-text">{{constants.CITY_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': natureActive}">
                    <input class="tag-checkbox" id="nature" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="nature" id="nature-label" class="label-text">{{constants.NATURE_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': nightActive}">
                    <input class="tag-checkbox" id="night" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="night" id="night-label" class="label-text">{{constants.NIGHT_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': dayActive}">
                    <input class="tag-checkbox" id="day" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="day" id="day-label" class="label-text">{{constants.DAY_TXT}}</label>
                </div>
                <div class="checkbox-button " [ngClass]="{'checkbox-button-active':interiorActive}">
                    <input class="tag-checkbox" id="interior" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="interior" id="interior-label" class="label-text">{{constants.INTERIORS_TXT}}</label>
                </div>
                <div class="checkbox-button " [ngClass]="{'checkbox-button-active':waterActive}">
                    <input class="tag-checkbox" id="water" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="water" id="water-label" class="label-text">{{constants.WATER_TXT}}</label>
                </div>
            </div>



            <div class="button-container">
                <button [disabled]="prevDisable || currentIndex === 0 || isProcessing" (click)="onClickPrev()"
                    class="video-change-1">{{constants.PREV_TXT}}</button>
                <button [disabled]="isProcessing || isVimeoProcessing" (click)="openApproveDialog(approveDialog)" class="button-accept">
                    <span *ngIf="isApproving" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                    {{constants.ACCEPT_TXT}}</button>
                <button (click)=onClickDecline() class="button-reject" [disabled]="isProcessing || isVimeoProcessing">{{constants.DECLINE_TXT}}</button>
                <button [disabled]="nextDisable || currentIndex === videos.length - 1 || isProcessing" (click)=onClickNext()
                    class="video-change-2">{{constants.NEXT_TXT}}</button>
            </div>
        </div>
        <div class="col-6  table-responsive">
            <table class="table">
                <tbody>
                    <tr *ngIf="isLoading">
                        <div *ngFor="let item of skeltonArray">
                            <td>
                                <img style="width: 81%;" [src]="item" alt="">
                            </td>
                        </div>
                    </tr>
                    <tr *ngIf="!isLoading">
                        <div *ngIf="videos?.length === 0">
                            <td>
                                <p class="error">List is empty...
                                </p>
                            </td>
                        </div>
                    </tr>
                    <tr id="{{video.videoName}}"
                        *ngFor="let video of videos |filter:videoTitle | paginate: { itemsPerPage: itemsPerPage, currentPage: p }; let i = index">
                        <td *ngIf="!isLoading" [ngClass]="{'selected-row': currentIndex === getAbsoluteIndex(i)}">
                            <div class="row">
                                <!-- <div class="col-8 table-card" (click)="onclickRow(video)">
                                    <div class="icon-container">
                                        <video class="pending-video-icon" src="{{video.url}}">
                                        </video>
                                        <!-- <img class="pending-video-icon" src="https://lifebuzz.gr/wp-content/uploads/2020/11/windows-swap-i-efarmogi-pou-mporeis-na-deis-ti-thea-apo-to-parathyro-kapoiou-allou-se-olo-ton-kosmo-758x402.jpg"> --.
                                    </div>
                                     <!-- <div class="pending-video-title" id="pending-video-title" [ngClass]="{'backgroundTest': video.showErrorMessage}">
                                        <h6 id="{{video.videoName}}-title">{{video.videoTitle}}</h6>
                                        <span style="font-size: 14px;">{{video.uploadedOn}}</span>
                                        <p *ngIf="video.showErrorMessage">Error</p>

                                    </div>
                                 
                                </div> -->
                                <div class="col-8 table-card" (click)="onclickRow(video)">
                                    <div class="icon-container">
                                        <ng-container *ngIf="!video.showErrorMessage; else imageContainer">
                                            <img class="pending-video-icon" [src]="video.thumbnail"/>
                                        </ng-container>
                                        <ng-template #imageContainer>
                                            <img class="pending-video-icon" [src]="video.thumbnail"
                                               >
                                        </ng-template>
                                    </div>
                                    <div class="pending-video-title" id="pending-video-title">
                                        <h6 id="{{video.videoName}}-title">{{video.videoTitle}}</h6>
                                        <span style="font-size: 14px;">{{video.uploadedOn}}</span>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <h6 (click)="onClickName(video)" class="pending-video-creator">{{video.creatorName}}
                                    </h6>
                                    <button (click)="copyEmail(video, $event)" class="pending-copy-mail"
                                        id="{{video.videoName}}-pending">{{constants.COPY_TXT}}</button>
                                    <span>
                                        <button [disabled]='video.isDeleting || isProcessing' (click)=openDialog(myDialog,video.videoName) class="delete-button"><img *ngIf="!video.isDeleting" src="{{constants.BASKET_IMG}}"
                                                alt="" name="{{video.videoName}}"><mat-progress-spinner *ngIf="video.isDeleting" mode="indeterminate" diameter="24" color="primary">
                                                </mat-progress-spinner>
                                        </button>                                    
                                    </span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination-controls class="my-pagination" (pageChange)="onPageChange($event)"></pagination-controls>
        </div>
    </div>
</div>
<div class="modal-reject" id="modal-reject">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{constants.DECLINE_REASON_HEADING_TXT}}</h5>
            </div>
            <div class="modal-body">
                <form class="container-fluid" [formGroup]="declineMessage">
                    <div class="row">
                        <div class="col">
                            <div class="form-group ">
                                <div class="form-check">
                                    <input (change)="onClickCheck($event)" type="checkbox" class="form-check-input"
                                        id="check1" formControlName="0">
                                    <label class="form-check-label"
                                        for="check1">{{constants.DECLINE_REASON_1_TXT}}</label>
                                </div>
                                <div class="form-check">
                                    <input (change)="onClickCheck($event)" type="checkbox" class="form-check-input"
                                        id="check2" formControlName="1">
                                    <label class="form-check-label"
                                        for="check2">{{constants.DECLINE_REASON_2_TXT}}</label>
                                </div>
                                <div class="form-check">
                                    <input (change)="onClickCheck($event)" type="checkbox" class="form-check-input"
                                        id="check3" formControlName="2">
                                    <label class="form-check-label"
                                        for="check3">{{constants.DECLINE_REASON_3_TXT}}</label>
                                </div>
                                <div class="form-check">
                                    <input (change)="onClickCheck($event)" type="checkbox" class="form-check-input"
                                        id="check4" formControlName="3">
                                    <label class="form-check-label"
                                        for="check4">{{constants.DECLINE_REASON_4_TXT}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group ">
                            <div class="col">
                                <div class="form-check">
                                    <input (change)="onClickCheck($event)" type="checkbox" class="form-check-input"
                                        id="check5" formControlName="4">
                                    <label class="form-check-label"
                                        for="check5">{{constants.DECLINE_REASON_5_TXT}}</label>
                                </div>
                                <div class="form-check">
                                    <input (change)="onClickCheck($event)" type="checkbox" class="form-check-input"
                                        id="check6" formControlName="5">
                                    <label class="form-check-label"
                                        for="check6">{{constants.DECLINE_REASON_6_TXT}}</label>
                                </div>
                                <div class="form-check">
                                    <input (change)="onClickCheck($event)" type="checkbox" class="form-check-input"
                                        id="check7" formControlName="6">
                                    <label class="form-check-label"
                                        for="check7">{{constants.DECLINE_REASON_7_TXT}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <textarea class="form-control" id="message-text" formControlName="custom"
                            placeholder="Custom message for creator (optional)"></textarea>
                    </div>
                    <button id="confirm-button" (click)="onClickReject($event)" [disabled]="isdisabled || isDeclining"
                        class="decline-conform-button">
                        <span *ngIf="isDeclining" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        {{constants.CONFIRM_TXT}}</button>
                    <button (click)="onClosePopup()" data-dismiss="modal" id="close-button"
                        [disabled]="isdisabled || isDeclining" class="decline-close-button">
                        updated successfully!! </button>
                    <button (click)=ClickModalReject() class="close-button">
                        Close</button>
                </form>
            </div>
        </div>
    </div>
</div>
<ng-template #myDialog>
    <mat-dialog-content class="mat-typography">
        <p class="delete-title">Are you sure you want to permanently delete <b>{{currentVideoTitle}}</b>'s window?<br/> This action is irreversible</p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-button mat-dialog-close class="deleteButton" (click)="onClickDelete()">
            Delete
        </button>
        <button mat-button [mat-dialog-close]="true" class="cancelButton" cdkFocusInitial>
            Cancel
        </button>
    </mat-dialog-actions>
</ng-template>
<ng-template #approveDialog>
    <mat-dialog-content class="mat-typography">
        <p class="delete-title">Are you sure you want to approve <b>{{currentVideoTitle}}</b>'s window?<br/></p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-button mat-dialog-close class="deleteButton" (click)="onClickApprove()">
            Approve
        </button>
        <button mat-button [mat-dialog-close]="true" class="cancelButton" cdkFocusInitial>
            Cancel
        </button>
    </mat-dialog-actions>
</ng-template>